import React, { useEffect, useState, useMemo } from "react";
import Image from "../../../component/image/Image";
import CloseIcon from "../../../assets/images/clients/close-white.svg";
import Input from "../../../component/input/Input";
import Select from "../../../component/multiSelect/MultiSelect";
import { useLocation, useParams } from "react-router-dom";
import SingleSelect from "../../../component/singleSelect/SingleSelect";
import { useSelector } from "react-redux";
import useClientConfig from "../../../config/careers/clientConfig";




const JobFilterClient = (props: any) => {

    const { setTableControl, tableControl, filterListData, searchControlSubmit, withinDisabled, withinDisabledLocClass } = props;

    const [optimizeSearchBox, setOptimizeSearchBox] = useState("");
    const clientId = useParams();
    const location = useLocation();
    const clientConfig = useSelector((state: any) => state.careers.cliendConfig);
    const {clientSiteSettings,clientAssetsLink} = useClientConfig();
    const templateName = clientSiteSettings?.templateName;
    const customClientFolderName = clientSiteSettings?.customClientFolderName;
    useEffect(() => {
        if(templateName === "template_4" && location.pathname === "/"){
            setOptimizeSearchBox("");
        } else if(templateName === "template_4" && clientId?.from !== "direct"){
            setOptimizeSearchBox("module-careers-filters-apply-new");
        }
    }, [location.pathname, clientConfig]);

    const submitSearch = () => {
        searchControlSubmit();
    };

    const jobListingColorSettings = useMemo(() => {
        const colorSettings = clientConfig?.data?.data?.clientSettings?.colorSettings?.jobListing;
        return colorSettings?.[0];
      }, [clientConfig]);
    
    // const selectOption = (keyword: string, e: any) => {
    //     let value = e.target.value;
    //     let result = "";

    //     if(keyword === "distance"){
    //         result = (filterListData.jobDistances)?.find((distance: any) => (distance?.value === Number(value)));
    //     }
        
    //     return result;
    // };

    return (
        <>

                <style>
                    {`

                    :root {
                        --mobile-filter-bg: ${jobListingColorSettings?.moileFilterBackground};
                        --mobile-field-filter-bg: ${jobListingColorSettings?.mobileFilterFieldBg};
                    }
                       
                       
                    `}
                </style>
            {(templateName === "template_9" && !customClientFolderName) ? ( 
            <div className="core-value-section">
                <div className="core-value-container">
                    <div className="core-value-heading">Core Values</div>
                    <div className="core-value-list-parent">
                        <div className="core-value-list">
                            <div className="core-value-img">
                                <img src={clientAssetsLink+"/core-value-img1.svg"} alt="" decoding="async"  />
                            </div> 
                            <div className="core-value-title">
                                Unwavering Excellence
                            </div> 
                            <div className="core-value-content">
                                Striving for the highest standards in all our endeavours.
                            </div>     
                        </div>    
                        <div className="core-value-list">
                            <div className="core-value-img">
                                <img src={clientAssetsLink+"/core-value-img2.svg"} alt="" decoding="async"  />
                            </div> 
                            <div className="core-value-title">
                                Integrity
                            </div> 
                            <div className="core-value-content">
                                Committing to honesty, transparency, and ethical behaviour in every interaction.
                            </div>     
                        </div> 
                        <div className="core-value-list">
                            <div className="core-value-img">
                                <img src={clientAssetsLink+"/core-value-img3.svg"} alt="" decoding="async"  />
                            </div> 
                            <div className="core-value-title">
                                Dependability
                            </div> 
                            <div className="core-value-content">
                                Ensuring reliability and consistency in our products.
                            </div>     
                        </div> 
                        <div className="core-value-list">
                            <div className="core-value-img">
                                <img src={clientAssetsLink+"/core-value-img4.svg"} alt="" decoding="async"  />
                            </div> 
                            <div className="core-value-title">
                                Care
                            </div> 
                            <div className="core-value-content">
                                Demonstrating genuine concerns for the well-being of our customers, employees, and the environment.
                            </div>     
                        </div>                    
                    </div>                         
                </div>                              
            </div>
            ) : ""}

            <div className={`module-careers-filters ${optimizeSearchBox}`}>
                <form className="flex justify-between">
                    <input type="checkbox" className="filters-checkbox" />
                    <div className="heading">
                        <div className="icon">
                            {/* <Image src={FiltersIcon} alt="filters" /> */}
                            <svg width="31" height="18" viewBox="0 0 31 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g id="Group 119">
                                    <g id="Glyph">
                                        <path id="Vector" d="M10.3296 0.0952308C9.4921 0.0975847 8.67579 0.358936 7.99262 0.843454C7.30945 1.32797 6.79287 2.01194 6.51369 2.80158H2.2106C1.85171 2.80158 1.50753 2.94415 1.25376 3.19792C0.999988 3.45169 0.857422 3.79587 0.857422 4.15476C0.857422 4.51364 0.999988 4.85782 1.25376 5.11159C1.50753 5.36536 1.85171 5.50793 2.2106 5.50793H6.51369C6.76194 6.21006 7.19854 6.83038 7.77572 7.30099C8.35291 7.7716 9.04842 8.07437 9.78616 8.17616C10.5239 8.27796 11.2754 8.17485 11.9585 7.87813C12.6415 7.58141 13.2298 7.10251 13.6589 6.49384C14.088 5.88518 14.3414 5.17019 14.3914 4.42715C14.4414 3.6841 14.286 2.94163 13.9423 2.28098C13.5985 1.62033 13.0797 1.06697 12.4425 0.681461C11.8053 0.295949 11.0744 0.0931399 10.3296 0.0952308ZM29.2741 2.80158H18.4487C18.0898 2.80158 17.7456 2.94415 17.4919 3.19792C17.2381 3.45169 17.0955 3.79587 17.0955 4.15476C17.0955 4.51364 17.2381 4.85782 17.4919 5.11159C17.7456 5.36536 18.0898 5.50793 18.4487 5.50793H29.2741C29.633 5.50793 29.9772 5.36536 30.2309 5.11159C30.4847 4.85782 30.6273 4.51364 30.6273 4.15476C30.6273 3.79587 30.4847 3.45169 30.2309 3.19792C29.9772 2.94415 29.633 2.80158 29.2741 2.80158ZM13.036 12.2738H2.2106C1.85171 12.2738 1.50753 12.4164 1.25376 12.6701C0.999988 12.9239 0.857422 13.2681 0.857422 13.627C0.857422 13.9859 0.999988 14.3301 1.25376 14.5838C1.50753 14.8376 1.85171 14.9802 2.2106 14.9802H13.036C13.3949 14.9802 13.7391 14.8376 13.9928 14.5838C14.2466 14.3301 14.3892 13.9859 14.3892 13.627C14.3892 13.2681 14.2466 12.9239 13.9928 12.6701C13.7391 12.4164 13.3949 12.2738 13.036 12.2738ZM29.2741 12.2738H24.971C24.6518 11.3709 24.0237 10.61 23.1977 10.1255C22.3717 9.64092 21.401 9.46398 20.4572 9.62592C19.5133 9.78785 18.6571 10.2782 18.0399 11.0104C17.4227 11.7426 17.0841 12.6694 17.0841 13.627C17.0841 14.5846 17.4227 15.5114 18.0399 16.2436C18.6571 16.9757 19.5133 17.4661 20.4572 17.628C21.401 17.79 22.3717 17.613 23.1977 17.1285C24.0237 16.644 24.6518 15.883 24.971 14.9802H29.2741C29.633 14.9802 29.9772 14.8376 30.2309 14.5838C30.4847 14.3301 30.6273 13.9859 30.6273 13.627C30.6273 13.2681 30.4847 12.9239 30.2309 12.6701C29.9772 12.4164 29.633 12.2738 29.2741 12.2738Z" fill="#314633"/>
                                    </g>
                                </g>
                            </svg>

                            <Image src={CloseIcon} alt="close" />
                        </div>
                        {/* {
                            templateName === "template_9" ? (
                                <h2 className="h2-client teal-purple">Be part of something <em>bigger</em><span className="stop">.</span></h2>
                            ) : (
                                <h2 className="h2-client teal-purple">Find your <em>future</em><span className="stop">.</span></h2>
                            )
                        } */}
                        {(() => {
                            if (customClientFolderName === "qimr") {
                                return (
                                    <h2 className="h2-client teal-purple">
                                        Your <em>journey</em> starts here 
                                        <span className="stop">.</span>
                                    </h2>
                                );
                            } else if (customClientFolderName === "cos") {
                                return (
                                    <h2 className="h2-client teal-purple">Careers at <em>City of Salisbury</em></h2>
                                );
                            } else if (templateName === "template_9") {
                                return (
                                    <h2 className="h2-client teal-purple">
                                        Be part of something <em>bigger</em>
                                        <span className="stop">.</span>
                                    </h2>
                                );
                            } else {
                                return (
                                    <h2 className="h2-client teal-purple">
                                        Find your <em>future</em>
                                        <span className="stop">.</span>
                                    </h2>
                                );
                            }
                        })()}
                    </div>
                    <div className="columns">
                        <div className="column">
                            <div className="form-fields search">
                                <div className="form-group dropdown-field multi-select jobcategory-select cust-common-select-dropdown">
                                    <label>Category</label>
                                    <Select className="form-control normal-text-input mq-normal-text-input" isSearchable={true} placeholder="All categories" isMulti={true} onChange={(e: any) => {
                                        setTableControl((prs: any) => {
                                            return {
                                                ...prs,
                                                searchCat: e
                                            };
                                        });
                                    }} value={tableControl.searchCat} options={filterListData.jobCategories} />
                                </div>
                                <div className="form-group dropdown-field multi-select jobcategory-select cust-common-select-dropdown">
                                    <label>Job types</label>
                                    {/* changed just because of CoS - given in mail */}
                                    {/* <label>Job Types</label> */} 
                                    <Select className="form-control normal-text-input mq-normal-text-input" isSearchable={true} placeholder="All jobs" isMulti={true} onChange={(e: any) => {
                                        setTableControl((prs: any) => {
                                            return {
                                                ...prs,
                                                searchJob: e
                                            };
                                        });
                                    }} value={tableControl.searchJob} options={filterListData.jobTypes} />
                                </div>
                                {(customClientFolderName !== "cos") && (
                                    <div className="form-group dropdown-field multi-select jobcategory-select cust-common-select-dropdown">
                                    <label>Locations</label>
                                    <Select className="form-control normal-text-input mq-normal-text-input" isSearchable={true} placeholder="All locations" isMulti={true}
                                        onChange={(e: any) => {
                                            setTableControl((prs: any) => {
                                                return {
                                                    ...prs,
                                                    searchLocation: e
                                                };
                                            });
                                        }} value={tableControl.searchLocation} options={filterListData.jobLocations} />
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="column">
                            <div className="form-fields">
                                <div className="form-group text-field cust-postcode-field">
                                        <label>Postcode</label>
                                        <Input type={"number"} maxLength={4} placeholder="Enter postcode" className="form-control mq-normal-text-input cust-number-field" value={tableControl.postCode}
                                            onChange={(e: { target: { value: any; }; }) =>
                                                setTableControl((prs: any) => {
                                                    return {
                                                        ...prs,
                                                        postCode: e.target.value
                                                    };
                                                })
                                            }
                                            />
                                    </div>
                                <div className="form-group dropdown-field">
                                    {/* <label>Within</label>
                                    <select className="form-control normal-text-input mq-normal-text-input select-form-control-active"
                                        placeholder="" onChange={(e: any) => {
                                        setTableControl((prs: any) => {
                                            return {
                                                ...prs,
                                                distanceRadius: selectOption("distance", e)
                                            };
                                        });
                                        }} value={tableControl.distanceRadius.value}>
                                        {/* <option value="All">{"All"}</option> */}
                                        {/* {filterListData.jobDistances?.map((ress: any, id: number) => {
                                            return (
                                                <option key={id} value={ress.value}>{ress.label}</option>
                                            );
                                        })} */}
                                    {/* </select>  */}
                                    <div className={`cust-common-select cust-common-select-dropdown cust-within-field  ${withinDisabledLocClass}`}>
                                        <label>Within</label>
                                        <SingleSelect className="joblist-multi-select distance-search" isDisabled={withinDisabled}
                                            placeholder="Any distance" onChange={(e: any) => {
                                                setTableControl((prs: any) => {
                                                    return {
                                                        ...prs,
                                                        distanceRadius: e
                                                    };
                                                });

                                            }}
                                        isClearable={true} value={tableControl.distanceRadius} options={filterListData.jobDistances} />
                                    </div>
                                    {withinDisabled ? <div className="disabled-location-status">Enable location access to use this filter.</div> : "" }
                                </div>
                                <div className="button-group">
                                    <button type="button" onClick={() => submitSearch()} className="butn"><span>Filter Search</span></button>
                                </div>
                                <div className="cutout">
                                    <div className="form-group text-field cust-search-jobs-by-keywords">
                                        <label>Search jobs by keywords</label>
                                        <Input
                                            className={`form-control active filter-in normal-text-input mq-normal-text-input ${tableControl.searchText ? "filter-in-active" : ""}`}
                                            type={"text"}
                                            value={tableControl.searchText}
                                            placeholder="Search jobs by keywords"
                                            name={"search"}
                                            onChange={(e: { target: { value: any; }; }) => {
                                                setTableControl((prs: any) => {
                                                    return {
                                                        ...prs,
                                                        searchText: e.target.value
                                                    };
                                                });
                                            }
                                            }
                                        />
                                    </div>
                                    <div className="button-group keyword-search-button">
                                        <button type="button" onClick={() => submitSearch()}>
                                            <svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g id="Layer_1">
                                                <path id="Vector" d="M20.9996 8.99956C20.9996 8.52317 20.815 8.06698 20.4869 7.73032L13.4872 0.547485C13.3256 0.375784 13.1328 0.239433 12.9195 0.145166C12.7054 0.0508988 12.4757 0.00208184 12.2436 -0.000443177C12.0114 -0.00212652 11.7809 0.0433238 11.566 0.133383C11.3511 0.223442 11.1558 0.357267 10.991 0.525602C10.8269 0.693936 10.6965 0.895096 10.6087 1.11561C10.5209 1.33613 10.4766 1.57264 10.4783 1.81084C10.4799 2.04903 10.5283 2.2847 10.6202 2.50353C10.7121 2.72237 10.845 2.921 11.0123 3.08597L15.0253 7.20343H1.74933C1.28503 7.20343 0.84042 7.3928 0.511475 7.72947C0.18335 8.06614 -0.0012207 8.52317 -0.0012207 8.99956C-0.000400391 9.47594 0.18417 9.93213 0.512295 10.2688C0.84042 10.6055 1.28585 10.7948 1.75015 10.7948H15.0253L11.0123 14.9123C10.845 15.0781 10.7121 15.2759 10.6202 15.4947C10.5283 15.7136 10.4799 15.9492 10.4783 16.1874C10.4766 16.4256 10.5209 16.6621 10.6087 16.8827C10.6965 17.1032 10.8269 17.3035 10.991 17.4727C11.155 17.641 11.3511 17.7748 11.566 17.8649C11.7809 17.9549 12.0114 18.0004 12.2436 17.9987C12.4757 17.997 12.7054 17.9474 12.9187 17.8531C13.132 17.7588 13.3256 17.6225 13.4864 17.4508L20.4861 10.2688C20.8142 9.93213 20.9988 9.4751 20.9988 8.99956H20.9996Z" fill="#314633"/>
                                                </g>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>


           
        </>
    );
};

export default JobFilterClient;